import { LOADING_STATE } from "types/general";
import { IState } from "./types";

export const COMPETITORS_SLICE_NAME = "competitors";

export const initialState: IState = {
  data: undefined,
  loadingState: LOADING_STATE.idle,
  filters: {
    careType: "overall",
  },
};
